import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppState } from '../app-state';

export interface HasUnsavedData {
  hasUnsavedData: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements  CanDeactivate<HasUnsavedData>{

  constructor( public appState: AppState ) {

  }

  // deactivate will be opposite of hasUnsavedData
  canDeactivate(component: HasUnsavedData) {

    const user = this.appState.getUser()
    const isLoggedIn = user?.token;
    if ( !isLoggedIn ) {
      return true
    }

    const hasUnsavedData = component?.hasUnsavedData();
    if ( typeof hasUnsavedData == 'boolean' ) {
      return !hasUnsavedData
    } else {
      const hasUnsavedDataObservable = hasUnsavedData as Observable<boolean>
      let deactivateSubject = new Subject<boolean>()
      hasUnsavedDataObservable.pipe(take(1)).subscribe(bHasUnsavedData=>deactivateSubject.next(!bHasUnsavedData))
      return deactivateSubject
    }    
  }

}
